import { Alert, ControlledCheckbox, FlexContainer } from '@act/storybook';
import type { Control, FieldValues, Path } from 'react-hook-form';

type FormWithHospitalizationFollowUp = FieldValues & {
  isHospitalizationFollowUp?: boolean;
};

export type HospitalizationFollowUpCheckboxSectionProps<
  TForm extends FormWithHospitalizationFollowUp =
    FormWithHospitalizationFollowUp,
> = {
  control: Control<TForm>;
  infoMessage: string;
  checkboxLabel: string;
  disabled?: boolean;
  checkboxTrackingName?: string;
};

/**
 * Info alert and hospitalization follow-up checkbox grouped with compact spacing.
 * @param props Form control, info copy, and checkbox state.
 * @returns Alert and checkbox for interaction follow-up selection.
 */
export function HospitalizationFollowUpCheckboxSection<
  TForm extends FormWithHospitalizationFollowUp =
    FormWithHospitalizationFollowUp,
>({
  control,
  infoMessage,
  checkboxLabel,
  disabled = false,
  checkboxTrackingName = 'hospitalization-follow-up-checkbox',
}: HospitalizationFollowUpCheckboxSectionProps<TForm>) {
  return (
    <FlexContainer direction="column" gap={0} width="100%" height="auto">
      <Alert severity="info">{infoMessage}</Alert>
      <ControlledCheckbox
        control={control}
        name={'isHospitalizationFollowUp' as Path<TForm>}
        label={checkboxLabel}
        disabled={disabled}
        trackingName={checkboxTrackingName}
      />
    </FlexContainer>
  );
}
